import {
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { switchMap, tap } from "rxjs/operators";
import { AppFlowService } from "src/app/services/app-flow.service";
import { ThemeService } from "src/app/services/theme.service";
import { Cliente } from "../../model/cliente.model";
import { FacecaptchaService } from "../../service/facecaptcha.service";

@Component({
  selector: "app-image-capture-oiti",
  templateUrl: "./image-capture-oiti.component.html",
  styleUrls: ["./image-capture-oiti.component.scss"],
})
export class ImageCaptureOitiComponent implements OnInit, OnDestroy {
  @Output()
  imageCapture = new EventEmitter<{ image: string; appKey: string }>();
  @Output()
  captureError = new EventEmitter<string>();

  cliente: Cliente = {
    cpf: "",
    nome: "",
    nascimento: "",
  };

  streams: any;
  appkey: any;
  challenge: any;
  fcvarFirstSnap: any = "";
  fcvarSnaps: any = "";
  msgBase64: string = "";
  emojiBase64: string = "";
  message: string = "Clique em INICIAR";
  showIniciar: Boolean = true;
  isLoaded: Boolean = false;

  constructor(
    private facecaptchaService: FacecaptchaService,
    private appFlowService: AppFlowService
  ) {}

  ngOnInit(): void {
	this.extrairDadosCliente();
    this.startCamera();
  }

  ngOnDestroy(): void {
    this.stopCameraStreams();
  }

  startCamera() {
    (navigator as any).getUserMedia = (
      (navigator as any).getUserMedia ||
      (navigator as any).webkitGetUserMedia ||
      (navigator as any).mozGetUserMedia ||
      (navigator as any).msGetUserMedia ||
      (navigator as any).mediaDevices.getUserMedia
    ) as any;

    // ajusta as configurações de video
    const constraints: any = {
      audio: false,
      video: {
        width: { exact: 640 },
        height: { exact: 480 },
      },
    };

    // se mobile, ajusta configurações de video para mobile
    if (this.isMobile()) {
      constraints.video = {
        width: { exact: 1280 },
        height: { exact: 720 },
        facingMode: "user",
      };
    }

    navigator.mediaDevices
      .getUserMedia(constraints)
      .then((stream) => this.handleStream(stream))
      .catch((err) => {
        console.log("No camera! " + err);
      });

    // verifica suporte a getUserMedia
    //	if (navigator.getUserMedia) {
    //		navigator.mediaDevices
    //			.getUserMedia(constraints)
    //			.then((stream) => this.handleStream(stream))
    //			.catch((err) => {
    //				console.log('No camera! ' + err);
    //			});
    //	} else {
    //		console.log('getUserMedia not supported');
    //	}
  }

  stopCameraStreams() {
    if (this.streams) {
      this.streams.forEach((stream: any) => {
        stream.stop();
      });
      this.streams = null;
    }
  }

  private isMobile() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    );
  }

  private handleStream(stream: any) {
    const video: any = document.getElementById("player");

    video.setAttribute("autoplay", "");
    video.setAttribute("muted", "");
    video.setAttribute("playsinline", "");

    video.srcObject = stream;
    this.streams = stream.getVideoTracks();
  }

  startCapture() {
    this.showIniciar = false;
    this.isLoaded = true;
    this.message = "Iniciando...";

    this.facecaptchaService
      .gerarAppKey(this.cliente)
      .pipe(
        tap((result: any) => (this.appkey = result.body.appkey)),
        switchMap((result) =>
          this.facecaptchaService.challenge(this.appkey)
        )
      )
      .subscribe(
        (response: any) => {
          this.challenge = response.body,
          this.isLoaded = false;
          this.prepareChallenge(0);
        },
        (error) => {
          console.log(error);
          this.isLoaded = false;
        }
      );
  }

  // Preparar desafios
  prepareChallenge(index: any) {
    var me = this;

    this.emojiBase64 = "";
    this.msgBase64 = "";
    this.message = "";

    if (index >= this.challenge.numberOfChallenges) {
      this.stopChallenge();
      return;
    }

    // Intervalo de captura de image do video
    for (let i = 1; i <= this.challenge.snapNumber; i++) {
      setTimeout(function () {
        me.snapTick(me.challenge.challenges[index]);
      }, this.challenge.snapFrequenceInMillis * i);
    }

    // atribui imagem Desafio (msg)
    this.msgBase64 =
      "data:image/jpeg;base64," + this.challenge.challenges[index].mensagem;

    // atribui imagem Desafio (emojji)
    this.emojiBase64 =
      "data:image/jpeg;base64," +
      this.challenge.challenges[index].tipoFace.imagem;

    setTimeout(function () {
      // Proximo desafio. Recursive
      index++;
      me.prepareChallenge(index);
    }, (this.challenge.totalTime / this.challenge.numberOfChallenges) * 1000);
  }

  // finaliza desafios
  stopChallenge() {
    this.message = "Enviando...";
    this.isLoaded = true;
    this.stopCameraStreams();

    this.facecaptchaService
      .captchaa(this.appkey, this.challenge.chkey, this.fcvarSnaps)
      .subscribe(
        (response: any) => {
          this.message = response.body.cause;
          this.isLoaded = false;

          //Se o retorno for invalido, trata o erro.
          if(response.body.codID === "300.1") {
            this.captureError.emit(this.trataRetorno(response.body.codID));
            return;
          }

          //A seguinte regex remove os metadatas que vem antes do base64 Ex: data:image/jpeg;base64;
          const encodedBase64Image = this.fcvarFirstSnap.replace(
            /^data:image\/(png|jpeg|jpg);base64,/,
            ""
          );

          this.imageCapture.emit({
            image: encodedBase64Image,
            appKey: this.appkey,
          });
          
          //this.router.navigate(['/send-document'], {queryParams: {"appKey": this.appkey}, skipLocationChange: true})
        },
        (error) => {
          console.log(error);
        }
      );
  }

  // prepara captura de imagem
  snapTick(fcvarCurCha: any) {
    let snapb64: any = this.snap();

    if (this.fcvarFirstSnap === "") {
      this.fcvarFirstSnap = snapb64;
    }

    // necessario adicionar o codigo do tipoFace entre o 'data:image/jpeg' e o snapb64
    snapb64 = snapb64.split("data:image/jpeg;base64,");
    snapb64 =
      "data:image/jpeg;base64," +
      snapb64[0] +
      "type:" +
      fcvarCurCha.tipoFace.codigo +
      "," +
      snapb64[1];

    this.fcvarSnaps += snapb64;
  }

  // captura imagem da câmera
  snap() {
    const video: any = document.getElementById("player");
    var canvas: any = document.getElementById("fc_canvas");
    var ctx = canvas.getContext("2d");

    ctx.canvas.width = 320;
    ctx.canvas.height = 480;

    var ratio = video.videoWidth / video.videoHeight;
    var widthReal,
      heightReal = 0;
    var startX,
      startY = 0;

    if (ratio >= 1) {
      // paisagem
      widthReal = video.videoHeight / 1.5;
      heightReal = video.videoHeight;

      startX = (video.videoWidth - widthReal) / 2;
      startY = 0;
    } else {
      // retrato
      ratio = video.videoHeight / video.videoWidth;

      // verifica proporção
      if (ratio > 1.5) {
        widthReal = video.videoWidth;
        heightReal = video.videoWidth * 1.5;

        startX = 0;
        startY = (video.videoHeight - heightReal) / 2;
      } else {
        widthReal = video.videoHeight / 1.5;
        heightReal = video.videoHeight;

        startX = (video.videoWidth - widthReal) / 2;
        startY = 0;
      }
    }

    // crop image video
    ctx.drawImage(
      video,
      startX,
      startY,
      widthReal,
      heightReal,
      0,
      0,
      ctx.canvas.width,
      ctx.canvas.height
    );

    var img = new Image();
    img.src = canvas.toDataURL("image/jpeg");

    return img.src;
  }

  //Pega os dados do cliente do form app state e atribui ao objeto Cliente que será passado na request.
  extrairDadosCliente() {
    const properties: any = this.appFlowService.getFormValues();

    if (
      properties.hasOwnProperty("pessoa.nome") &&
      properties.hasOwnProperty("pessoa.cpf") &&
      properties.hasOwnProperty("pessoa.dataNascimento")
    ) {

      this.cliente = {
        cpf: properties["pessoa.cpf"],
        nome: properties["pessoa.nome"],
        nascimento: new Date(
          properties["pessoa.dataNascimento"]
        ).toLocaleDateString("pt-BR"),
      };
	  
    }
  }

  trataRetorno(codId: string): string {
    

    switch (codId) {
      case "300.1":
        return "Cod.id 300.1: Prova de vida inválida. Por favor tente novamente.";
      case "300.2":
        return "Cod.id 300.2: Usuário foi bloqueado.";
      default:
        return "Erro. Favor contatar o suporte.";
    }
  }

}
